var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-breadcrumbs',{staticClass:"breadcrumbs",attrs:{"items":_vm.items,"divider":"/"},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('router-link',{staticClass:"link",attrs:{"to":{ name: props.item.href }}},[_vm._v(_vm._s(props.item.name))])]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d03488b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/Breadcrumbs.vue
// module id = null
// module chunks = 